import { Component, Inject, ViewEncapsulation, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material';
import { MatColors } from '@fuse/mat-colors';
import { CalendarEventModel } from '../event.model';
import { Observable } from 'rxjs';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { DateConvertor } from 'app/shared/common/helper/dateConvertor';
import { ToastrService } from 'ngx-toastr';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { CalendarService } from '../calendar.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { CommonValidation } from 'app/shared/common/common-validation';
import { RichTextEditorComponent } from '@syncfusion/ej2-angular-richtexteditor';
import { createElement, addClass, removeClass, Browser } from '@syncfusion/ej2-base';
import * as CodeMirror from 'codemirror';
import 'codemirror/mode/javascript/javascript';
import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import { HttpClient } from '@angular/common/http';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { DatePipe } from '@angular/common';
import { SocketService } from 'app/shared/common/helper/socket.service';
import { DataService } from 'app/shared/common/helper/http-service';
import { Configuration } from 'app/app.configuration';

@Component({
    selector: 'calendar-event-form-dialog',
    templateUrl: './event-form.component.html',
    styleUrls: ['./event-form.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class CalendarEventFormDialogComponent implements OnInit {

    tags: any[];
    formType: string;
    reportingTo: any;
    action: string;
    event: any;
    permissionForm: FormGroup;
    prePostLeaveForm: FormGroup;
    dialogTitle: string;
    board: any;
    card: any;
    list: any;
    clientId: any;
    eventTypeValue: any;
    presetColors = MatColors.presets;
    type: any;
    taskId: any;
    meetingId: any;
    tagArray = [];
    members = [];
    assigneesId = [];
    buttonTrigger: any = false;
    rejectReason: string = '';
    dateDisabled = true;
    startDate: Date;
    endDate: Date;
    appliedDate: Date;
    empRole = '';
    profileIe = '';
    firstname: String = '';
    lastname: String = '';
    filteredClientOptions: Observable<User[]>;
    profileId = '';
    currentuser: any;
    eventType: any;
    readLeave = false;
    readPermission = false;
    allowAccess = false;
    canEdit = false;
    memberId = [];
    commentData = [];
    noData = false;
    newDate = Date.now();
    organizerImage: any;
    organizerName: string;
    selectedSessionType = '';
    requestedName: string;
    requesterImage: any;
    userId = this.parseService.instance.User.current().id;
    events: any[] = [
        { value: 'Leave', viewValue: 'Leave' },
    ];
    leaves: any[] = [
        { value: 'Permission', viewValue: 'Permission' },
        { value: 'Leave', viewValue: 'Leave' }
    ];

    Meeting: any[] = [
        { value: 'Cancelled', viewValue: 'Cancelled' },
        { value: 'Completed', viewValue: 'Completed' }
    ];

    leavesType: any[] = [
        { value: 'Casual-Leave', viewValue: 'Casual-Leave' },
        { value: 'Half-Day-Leave', viewValue: 'Half-Day-Leave' },
        { value: 'Sick-Leave', viewValue: 'Sick-Leave' },
        { value: 'CompOff-Leave', viewValue: 'CompOff-Leave' },
        { value: 'Maternity-Leave', viewValue: 'Maternity-Leave' },
        { value: 'Marriage-Leave', viewValue: 'Marriage-Leave' },
        { value: 'Medical-Leave', viewValue: 'Medical-Leave' }
    ];

    sessionTypes: any[] = [
        { value: 'FN', viewValue: 'FN' },
        { value: 'AN', viewValue: 'AN' }
    ];

    meetings: any[] = [
        { value: 'Internal Meeting', viewValue: 'Internal Meeting' },
        { value: 'Client-Meeting', viewValue: 'Client-Meeting' },
    ];

    meetingStatus: any[] = [
        { value: 'Pending', viewValue: 'Pending' },
        { value: 'Cancelled', viewValue: 'Cancelled' },
        { value: 'Completed', viewValue: 'Completed' }
    ];
    hours: Hour[] = [
        { value: '1', viewValue: '1 Hour' },
        { value: '2', viewValue: '2 Hours' }
    ];
    options: User[] = [];
    @ViewChild('rejectPopup', { static: false }) rejectPopup: TemplateRef<any>;
    @ViewChild('confirmPopup', { static: false }) confirmPopup: TemplateRef<any>;
    @ViewChild('approvePopup', { static: false }) approvePopup: TemplateRef<any>;
    @ViewChild('cancelPopup', { static: false }) cancelPopup: TemplateRef<any>;
    @ViewChild('leaveCancelPopup', { static: false }) leaveCancelPopup: TemplateRef<any>;
    @ViewChild('titleInput', { static: false }) titleInputField;
    image: any;
    username: any;
    @ViewChild('toolsRTE', { static: false }) public rteObj: RichTextEditorComponent;
    public tools: object = {
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough',
            'FontName', 'FontSize', 'FontColor', 'BackgroundColor',
            'LowerCase', 'UpperCase', '|',
            'Formats', 'Alignments', 'OrderedList', 'UnorderedList',
            'Outdent', 'Indent', '|',
            'CreateTable', 'CreateLink', '|', '|', 'Undo', 'Redo']
    };
    public maxLength: number = 2000;
    public textArea: HTMLElement;
    public myCodeMirror: any;
    ownerImage: any;
    meetingCanEdit: boolean = false;
    emailTriggerValue: any;
    leaveValue: any;
    reqImage: any;
    currentUserName: any;
    rejectedProjectId: any;
    requestedProfileId: any;
    leaveReporterName: any;
    userLeaveReqId: any;
    endTimeVal: any;
    startTimeVal: any;
    startTimeSplit: any;
    endTimeSplit: any;
    selectHoursValue: number;
    selectedHours: any;
    hoursDropdown: any;
    newhours: any;
    selectedLeaveType = '';
    currentDate = new Date();
    tomorrowDate = new Date();
    datePipe = new DatePipe('en-US');
    leaveResults = [];
    showDetails = false;
    confirmDialRef: MatDialogRef<any, any>;
    rejectDialog: MatDialogRef<any, any>;
    approveDialog: MatDialogRef<any, any>;
    cancelDialog: MatDialogRef<any, any>;
    cancelLeaveDialog: MatDialogRef<any, any>;
    /**
    * Constructor
    *
    * @param {MatDialogRef<CalendarEventFormDialogComponent>} matDialogRef
    * @param _data
    * @param {FormBuilder} _formBuilder
    */
    constructor(
            public matDialogRef: MatDialogRef<CalendarEventFormDialogComponent>,
            private dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _formBuilder: FormBuilder,
        private parseService: ParseService,
        private dateConvertor: DateConvertor,
        private toastr: ToastrService,
        public dialog: MatDialog,
        private queryInterface: QueryInterface,
        private _calendarService: CalendarService,
        private storageConfiguration: StorageConfiguration,
        private commonValidation: CommonValidation,
        private _httpClient: HttpClient,
        private dateServiceService: DateServiceService,
        private _socket: SocketService,
        private dataService: DataService,
        private configuration: Configuration
    ) {
        this.getTags();
        this.currentuser = this.parseService.instance.User.current();
        this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
        this.profileId = this.currentuser.get('profile').id;
        this.firstname = this.currentuser.get('firstName');
        this.lastname = this.currentuser.get('lastName');
        this.username = this.currentuser.get('username');
        this.event = _data.event;
        this.action = _data.action;
        this.type = _data.type;
        this.image = this.currentuser.get('profile').get('profileImageInfo').url;

        if (this.empRole == 'Employee' || this.empRole == 'Leader' || this.empRole == 'HR' || this.empRole == 'Admin') {
            this.eventType = 'Leave'; this.eventTypeValue = 'Leave';
        }
        if (this.action === 'edit') {
            let title = this.dialogTitle = this.event.title;
            if (title.includes('Leave')) {
                this.eventType = 'Leave';
                this.eventTypeValue = 'Leave';
            }
            else if (title.includes('Per')) {
                this.eventType = 'Leave';
                this.eventTypeValue = 'Permission';
            }
        }
        else {
            this.dialogTitle = 'New Event';
            this.event = new CalendarEventModel({
                start: _data.date,
                end: _data.date
            });
        }
    }
    nonWorkingDays = [];

    async ngOnInit() {
        this.createForm();
        this.prePostLeaveForm.patchValue({
            appliedDate: new Date()
        });

        this.permissionForm.patchValue({
            appliedDate: new Date()
        });

        const currentYear = new Date().getFullYear();
        const holidaysInstance = this.parseService.instance.Object.extend('Holidays');
        const holidayQuery = new this.parseService.instance.Query(holidaysInstance);
        holidayQuery.equalTo('year', currentYear);
        const leaveResults = await holidayQuery.find();
        if (leaveResults.length > 0) {
            let holidayList = leaveResults[0].get('dateList') == undefined ? {} : leaveResults[0].get('dateList');
            for (let months in holidayList) {
                if (holidayList[months].length != 0) {
                    let parsedMonths = parseInt(months);
                    holidayList[months].forEach(element => {
                        const officialLeaves = new Date(currentYear, parsedMonths, element);
                        const epochLeaves = officialLeaves.getTime();
                        this.nonWorkingDays.push(epochLeaves);
                    });
                }
            }
        }
        let date = new Date();
        let year = date.getFullYear();
        let totalMonths = 12;
        for (let i = 0; i < totalMonths; i++) {
            let k = i + 1;
            let daysInMonth = new Date(year, k, 0).getDate();
            for (let j = 0; j < daysInMonth; j++) {
                let datesAll = new Date(year, i, j);
                let dayOfWeek = datesAll.getDay();
                let dateOfMonth = datesAll.getDate();
                let isEvenWeek = Math.ceil(dateOfMonth / 7);
                let epochOddDates = datesAll.getTime();
                if (dayOfWeek == 0) {
                    if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
                        this.nonWorkingDays.push(epochOddDates);
                    }
                } if (dayOfWeek == 6 && isEvenWeek % 2 != 0) {
                    if (this.nonWorkingDays.indexOf(epochOddDates) === -1) {
                        this.nonWorkingDays.push(epochOddDates);
                    }
                }
            }
        }
        let previousYear = year - 1;
        let daysInMonthLast = new Date(previousYear, 12, 0).getDate();
        for (let d = 1; d <= daysInMonthLast; d++) {
            let lastdatesAll = new Date(previousYear, 11, d);
            let lastdayOfWeek = lastdatesAll.getDay();
            let lastdateOfMonth = lastdatesAll.getDate();
            let lastisEvenWeek = Math.ceil(lastdateOfMonth / 7);
            let lastepochOddDates = lastdatesAll.getTime();
            if (lastdayOfWeek == 0) {
                if (this.nonWorkingDays.indexOf(lastepochOddDates) === -1) {
                    this.nonWorkingDays.push(lastepochOddDates);
                }
            } if (lastdayOfWeek == 6 && lastisEvenWeek % 2 != 0) {
                if (this.nonWorkingDays.indexOf(lastepochOddDates) === -1) {
                    this.nonWorkingDays.push(lastepochOddDates);
                }
            }
        }

        this.getReportingToId();

        if (this.action === 'edit') {
            this.formValuePatch();
            if (this.prePostLeaveForm.get('status').value === 'Approved' ||
                this.prePostLeaveForm.get('status').value === 'Cancelled') {
                this.readLeave = true;
            }

            if (this.permissionForm.get('status').value === 'Approved' ||
                this.permissionForm.get('status').value === 'Cancelled') {
                this.readPermission = true;
            }
            if (this.event.reporterId == this.profileId) {
                this.allowAccess = true;
            }
            if (this.event.requesterId === this.profileId) {
                this.canEdit = true;
            }
            if (this.empRole === 'Leader' || this.empRole === 'Admin') {
                if (this.event.requesterId !== this.profileId) {
                    this.readLeave = true;
                    this.readPermission = true;
                }
            }
        }
    }

    getTags(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._httpClient.get('api/todo-tags')
                .subscribe((response: any) => {
                    this.tags = response;
                    resolve(this.tags);
                }, reject);
        });
    }

    ngAfterViewInit(): void {
        let rteObj: RichTextEditorComponent = this.rteObj;
        if (rteObj != undefined) {
            setTimeout(() => { this.textArea = rteObj.contentModule.getEditPanel() as HTMLElement; }, 600);
        }
    }

    public mirrorConversion(e?: any): void {
        let id: string = this.rteObj.getID() + 'mirror-view';
        let mirrorView: HTMLElement = this.rteObj.element.querySelector('#' + id) as HTMLElement;
        let charCount: HTMLElement = this.rteObj.element.querySelector('.e-rte-character-count') as HTMLElement;
        if (e.targetItem === 'Preview') {
            this.textArea.style.display = 'block';
            mirrorView.style.display = 'none';
            this.textArea.innerHTML = this.myCodeMirror.getValue();
            charCount.style.display = 'block';
        } else {
            if (!mirrorView) {
                mirrorView = createElement('div', { className: 'e-content' });
                mirrorView.id = id;
                this.textArea.parentNode.appendChild(mirrorView);
            } else {
                mirrorView.innerHTML = '';
            }
            this.textArea.style.display = 'none';
            mirrorView.style.display = 'block';
            this.renderCodeMirror(mirrorView, this.rteObj.value);
            charCount.style.display = 'none';
        }
    }

    public renderCodeMirror(mirrorView: HTMLElement, content: string): void {
        this.myCodeMirror = CodeMirror(mirrorView, {
            value: content,
            lineNumbers: true,
            mode: 'text/html',
            lineWrapping: true,

        });
    }

    public handleFullScreen(e: any): void {
        const sbCntEle: HTMLElement = document.querySelector('.sb-content.e-view');
        const sbHdrEle: HTMLElement = document.querySelector('.sb-header.e-view');
        const leftBar: HTMLElement = document.querySelector('#left-sidebar');
        if (e.targetItem === 'Maximize') {
            if (Browser.isDevice && Browser.isIos) {
                addClass([sbCntEle, sbHdrEle], ['hide-header']);
            }
            addClass([leftBar], ['e-close']);
            removeClass([leftBar], ['e-open']);
        } else if (e.targetItem === 'Minimize') {
            if (Browser.isDevice && Browser.isIos) {
                removeClass([sbCntEle, sbHdrEle], ['hide-header']);
            }
            removeClass([leftBar], ['e-close']);
            if (!Browser.isDevice) {
                addClass([leftBar], ['e-open']);
            }
        }
    }

    public actionCompleteHandler(e: any): void {
        if (e.targetItem && (e.targetItem === 'SourceCode' || e.targetItem === 'Preview')) {
            (this.rteObj.sourceCodeModule.getPanel() as HTMLTextAreaElement).style.display = 'none';
            this.mirrorConversion(e);
        }
        else {
            setTimeout(() => { this.rteObj.toolbarModule.refreshToolbarOverflow(); }, 400);
        }
    }

    formValuePatch() {
        if (this.eventTypeValue == 'Permission' || this.eventTypeValue == 'Leave') {
            var requester = new this.parseService.instance.Object('Profile');
            requester.id = this.event.requesterId;
            this.userLeaveReqId = requester.id
            this.requestedName = requester.get('firstName') + ' ' + requester.get('lastName');
            this.requesterImage = requester.get('profileImageInfo').url ? requester.get('profileImageInfo').url : '';
        }
        switch (this.eventType) {
            case 'Leave':
                this.selectedLeaveType = this.event.leaveType;
                if (this.eventTypeValue !== 'Permission') {
                    this.prePostLeaveForm.patchValue({
                        startDate: this.event.start,
                        endDate: this.event.end,
                        reason: this.event.reason,
                        leaveType: this.event.leaveType,
                        appliedDate: this.event.appliedDate,
                        backToWorkDate: this.event.backToWorkDate,
                        totalDays: this.event.totalDays,
                        status: this.event.status,
                        sessionType: this.event.sessionType,
                        rejectReason: this.event.rejectReason,
                    });
                    this.tomorrowDate = new Date(this.event.backToWorkDate);
                }
                else {
                    this.startTimeVal = this.event.startTime;
                    this.endTimeVal = this.event.endTime;
                    this.startTimeSplit = this.endTimeVal.split(":");
                    this.endTimeSplit = this.startTimeVal.split(":");
                    this.selectHoursValue = Number(this.startTimeSplit[0]) - Number(this.endTimeSplit[0]);
                    this.permissionForm.patchValue({
                        startDate: this.event.start,
                        endDate: this.event.end,
                        appliedDate: this.event.appliedDate,
                        startTime: this.event.startTime,
                        endTime: this.event.endTime,
                        reason: this.event.reason,
                        status: this.event.status,
                        rejectReason: this.event.rejectReason,
                        sessionType: this.event.sessionType,
                        selectHour: String(this.selectHoursValue)
                    });
                }
                break;
        }
        this.getLeaveDetails();
    }

    createForm() {
        this.permissionForm = this._formBuilder.group({
            startDate: ['', Validators.required],
            endDate: ['', Validators.required],
            appliedDate: ['', Validators.required],
            startTime: ['', Validators.required],
            endTime: ['', Validators.required],
            selectHour: [''],
            reason: ['', Validators.required],
            sessionType: ['', Validators.required],
            rejectReason: [''],
            status: ['']
        });

        this.prePostLeaveForm = this._formBuilder.group({
            startDate: ['', Validators.required],
            endDate: ['', Validators.required],
            reason: ['', Validators.required],
            leaveType: ['', Validators.required],
            appliedDate: ['', Validators.required],
            backToWorkDate: ['', Validators.required],
            totalDays: ['', Validators.required],
            status: [''],
            sessionType: [''],
            rejectReason: ['']
        });
    }

    changeDate(event) {
        this.dateConvertor.momentChange(event.value);
        this.noOfDays();
        if (this.selectedLeaveType == 'Half-Day-Leave') {
            this.prePostLeaveForm.patchValue({
                endDate: new Date(this.prePostLeaveForm.value.startDate),
                totalDays: 0.5
            });
            if (this.selectedSessionType == 'FN') {
                if (this.prePostLeaveForm.value.startDate != '') {
                    this.currentDate = new Date(this.prePostLeaveForm.value.startDate);
                }
            }
            if (this.selectedSessionType == 'AN') {
                if (this.prePostLeaveForm.value.startDate != '') {
                    let date = new Date(this.prePostLeaveForm.value.startDate);
                    this.tomorrowDate = new Date(date.getTime() + 24 * 60 * 60 * 1000);
                }
            }
        }
        else {
            this.tomorrowDate = new Date(new Date(this.prePostLeaveForm.value.endDate).getTime() + 24 * 60 * 60 * 1000);
        }
    }

    getDaysArray = function (start, end) {
        for (var arr = [], dt = start; dt <= end; dt.setDate(dt.getDate() + 1)) {
            arr.push(new Date(dt).getTime());
        }
        return arr;
    };

    noOfDays() {
        this.startDate = new Date(this.prePostLeaveForm.value.startDate);
        this.endDate = new Date(this.prePostLeaveForm.value.endDate);
        this.appliedDate = new Date(this.prePostLeaveForm.value.appliedDate);
        var oneDay = 24 * 60 * 60 * 1000;

        let daylist = this.getDaysArray(new Date(this.startDate), new Date(this.endDate));
        let holidayList = [];
        for (var i = 0; i < daylist.length; i++) {
            let holiday = this.nonWorkingDays.filter(x => x === daylist[i]);
            if (holiday[0] != undefined) {
                holidayList.push(holiday[0]);
            }
        }

        var dateDifferences = Math.round(Math.abs((this.startDate.getTime() - this.endDate.getTime()) / (oneDay)));
        this.prePostLeaveForm.patchValue({
            totalDays: dateDifferences + 1 - holidayList.length
        });
        return dateDifferences;
    }

    statusUpdater(status, type) {
        if (status == 'Rejected' && !this.rejectReason) {
            this.toastr.warning('Reject Reason is required!!');
            return true;
        }
        this.close();
        switch (type) {
            case 'prePostLeaveForm':
                this.prePostLeaveForm.patchValue({
                    status: status,
                    rejectReason: this.rejectReason
                });
                this.updateLeave();
                break;
            case 'permissionForm':
                this.permissionForm.patchValue({
                    status: status,
                    rejectReason: this.rejectReason
                });
                this.updatePermission();
                break;
        }
    }

    prePostLeave() {
        if (this.eventTypeValue == 'Leave' || this.eventTypeValue == 'Pre-Leave' || this.eventTypeValue == 'Post-Leave') {
            if (this.action !== 'edit') {
                this.createLeave();
            }
            else {
                this.updateLeave();
            }
        }
        else if (this.eventTypeValue == 'Permission') {
            if (this.action !== 'edit') {
                this.permissionRequest();
            }
            else {
                this.updatePermission();
            }
        }
    }

    async getProfileId(profileId) {
        let queryInstance = this.parseService.instance.Object.extend("User")
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo("profile", { __type: "Pointer", className: "Profile", objectId: profileId });
        let results = await query.find();
        return results[0].id;
    }

    sessionType(event) {
        this.selectedSessionType = event.value;
        if (this.selectedSessionType == 'FN') {
            if (this.prePostLeaveForm.value.startDate != '') {
                this.currentDate = new Date(this.prePostLeaveForm.value.startDate);
            }
        }
        if (this.selectedSessionType == 'AN') {
            if (this.prePostLeaveForm.value.startDate != '') {
                let date = new Date(this.prePostLeaveForm.value.startDate);
                this.tomorrowDate = new Date(date.getTime() + 24 * 60 * 60 * 1000);
            }
        }
    }

    createLeave() {
        let values = this.prePostLeaveForm.value;
        let leaveFormValues = values;
        let leaveClass = this.parseService.instance.Object.extend('Leaves');
        var leave = new leaveClass();
        let subData = { eventTypeValue: this.eventTypeValue, reportingTo: this.reportingTo };
        leave = this._calendarService.LeaveForm(leave, values, subData, 'Create');
        if (this.prePostLeaveForm.valid) {
            leave.save().then(async (res) => {
                this.toastr.success('Leave Applied Successfully !');

                let requester = new this.parseService.instance.Object('Profile');
                requester.id = res.get('requesterId').objectId;

                let reporter = new this.parseService.instance.Object('Profile');
                reporter.id = res.get('reporterId').objectId;

                let userId = await this.getProfileId(res.get('requesterId').objectId);
                let assigignedProject = await this.getCurrentProjects(userId);
                let datePipe = new DatePipe('en-US');

                let context = {
                    name: reporter.get('firstName') + ' ' + reporter.get('lastName'),
                    fromDate: datePipe.transform(leaveFormValues.startDate, 'dd/MM/yyyy'),
                    toDate: datePipe.transform(leaveFormValues.endDate, 'dd/MM/yyyy'),
                    appliedDate: datePipe.transform(leaveFormValues.appliedDate, 'dd/MM/yyyy'),
                    reason: leaveFormValues.reason,
                    leaveStatus: res.get('status'),
                    totalDays: res.get('totalDays'),
                    profileImage: requester.get('profileImageInfo').url,
                    project: assigignedProject,
                    regardsName: requester.get('firstName') + ' ' + requester.get('lastName'),
                    email: reporter.get('email')
                };
                let data = {
                    context: context,
                    toEmail: context.email
                }
                this.dataService.add(this.configuration.leaveRequest, data).subscribe((data: any) => {
                });

                let sendSocket = {
                    event_type: 'LEAVE_REQUEST',
                    event_owner: {
                        id: this.parseService.instance.User.current().get('profile').id,
                        name: this.firstname + ' ' + this.lastname,
                    },
                    event_receiver: {
                        id: reporter.id,
                        name: reporter.get('firstName') + ' ' + reporter.get('lastName'),
                    },
                    message: this.firstname + ' ' + this.lastname + ' applied for a leave.',
                    event_created_Date: new Date(),
                    initiated_source: 'web'
                }
                this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);

                this._calendarService.getEvents();
            }, (error) => {
            });
            this.dialog.closeAll();
        }
        else {
            this.updateValidation(this.prePostLeaveForm);
        }
    }

    async updateLeave() {
        if (this.prePostLeaveForm.valid) {
            await this.queryInterface.executeQuery(this.parseService, 'Leaves', [{ condition: 'equalTo', field: 'objectId', value: this.event.leaveId },
            { condition: 'include', field: 'requesterId' }]).then(result => {
                let leave = result[0];
                let values = this.prePostLeaveForm.value;
                let subData = {
                    eventTypeValue: leave.get('requestType'),
                    reportingTo: this.reportingTo
                };
                leave = this._calendarService.LeaveForm(leave, values, subData, 'Edit');
                leave.save().then(async (res) => {
                    let status = res.get('status');
                    let requestType = res.get('requestType');
                    let leaveResult = res;

                    let userId = await this.getProfileId(leaveResult.get('requesterId').id);
                    let assigignedProject = await this.getCurrentProjects(userId);
                    let datePipe = new DatePipe('en-US');
                    let context = {
                        regardsName: this.requestedName,
                        fromDate: datePipe.transform(leaveResult.get('startDate'), 'dd/MM/yyyy'),
                        toDate: datePipe.transform(leaveResult.get('endDate'), 'dd/MM/yyyy'),
                        appliedDate: datePipe.transform(leaveResult.get('appliedDate'), 'dd/MM/yyyy'),
                        reason: leaveResult.get('reason'),
                        leaveStatus: leaveResult.get('status'),
                        totalDays: leaveResult.get('totalDays'),
                        profileImage: this.requesterImage,
                        project: assigignedProject,
                        name: leaveResult.get('reporterId').get('firstName') + ' ' + leaveResult.get('reporterId').get('lastName'),
                        email: leaveResult.get('requesterId').get('email')
                    };
                    let data = {
                        context: context,
                        toEmail: context.email
                    }
                    if (status === 'Approved') {
                        this.toastr.success(requestType + " " + 'Approved !');
                        this.dataService.add(this.configuration.leaveApprove, data).subscribe((data: any) => {
                        });
                    }
                    if (status === 'Rejected') {
                        this.toastr.error(requestType + " " + 'Rejected !');
                        this.dataService.add(this.configuration.leaveReject, data).subscribe((data: any) => {
                        });
                    }
                    if (status === 'Approved' || status === 'Rejected') {
                        let sendSocket = {
                            event_type: 'APPROVE_REJECT_LEAVE',
                            event_owner: {
                                id: this.parseService.instance.User.current().get('profile').id,
                                name: this.firstname + ' ' + this.lastname,
                            },
                            event_receiver: {
                                id: leaveResult.get('requesterId').id,
                                name: leaveResult.get('requesterId').get('firstName') + ' ' + leaveResult.get('requesterId').get('lastName'),
                            },
                            message: status + ' your leave request',
                            event_created_Date: new Date(),
                            initiated_source: 'web'
                        }
                        this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
                    }
                    this.toastr.success('Updated successfully');
                    this._calendarService.getEvents();
                }, (error) => {
                });
                this.dialog.closeAll();
            });
        }
        else {
            this.updateValidation(this.prePostLeaveForm);
        }
    }

    async getCurrentProjects(userId) {
        let result = [];
        let assignedProjects = '';
        let queryInstance = this.parseService.instance.Object.extend("ProjectMembers")
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo("isActive", true);
        query.include("project");
        query.include("project.client");
        query.equalTo("user", { __type: "Pointer", className: "_User", objectId: userId });
        query.equalTo("status", 'Assigned');
        let results = await query.find();
        for (let i = 0; i < results.length; i++) {
            let projectResults = JSON.parse(JSON.stringify(results[i]));
            result.push(
                projectResults.project.projectInfo.projectName,
            );
        }
        return assignedProjects = result.join(', ');
    }

    permissionRequest() {
        let values = this.permissionForm.value;
        let permissionData = {
            data: values,
            eventType: this.eventTypeValue,
            profileId: this.profileId,
            reportingTo: this.reportingTo
        }
        if (this.permissionForm.valid) {
            this._calendarService.addPermission(permissionData);
            this.dialog.closeAll();
        }
        else {
            this.updateValidation(this.permissionForm);
        }
    }

    async updatePermission() {
        if (this.permissionForm.valid) {
            let data = this.permissionForm.value;
            let permissionData = {
                data: data,
                permissionId: this.event.leaveId,
                eventType: this.eventTypeValue,
                requesterId: this.event.requesterId
            }
            this._calendarService.permissionUpdate(permissionData, 'edit');
            this.dialog.closeAll();
        }
        else {
            this.updateValidation(this.permissionForm);
        }
    }

    getReportingToId() {
        let queryInstance = this.parseService.instance.Object.extend('Profile');
        let query = new this.parseService.instance.Query(queryInstance);
        query.equalTo('objectId', this.profileId);
        query.find().then(results => {
            let reporter = results[0].get('reportingTo');
            this.reportingTo = reporter.id;
        });
    }

    displayFn(user?: User): string | undefined {
        return user ? user.name : undefined;
    }

    private _filter(name: string): User[] {
        const filterValue = name.toLowerCase();
        return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

    selectTypeValue(val): void {
        this.eventTypeValue = val;
        // if (this.eventTypeValue === 'Client-Meeting') {
        //     this.meetingForm.controls['meetingType'].setValidators([Validators.required]);
        //     this.meetingForm.controls['meetingType'].updateValueAndValidity();
        // }
        // else {
        //     this.meetingForm.controls['meetingType'].clearValidators();
        //     this.meetingForm.controls['meetingType'].updateValueAndValidity();
        // }
    }

    selectLeaveType(value) {
        this.selectedLeaveType = value;
        if (value == 'Half-Day-Leave') {
            this.prePostLeaveForm.patchValue({
                endDate: new Date(this.prePostLeaveForm.value.startDate),
                totalDays: 0.5,
            });
            this.prePostLeaveForm.controls['sessionType'].setValidators([Validators.required]);
            this.prePostLeaveForm.controls['sessionType'].updateValueAndValidity();
            if (this.selectedSessionType != 'FN') {
                this.tomorrowDate = new Date(new Date(this.prePostLeaveForm.value.startDate).getTime() + 24 * 60 * 60 * 1000);
            }
        }
        if (value != 'Half-Day-Leave') {
            this.tomorrowDate = new Date(new Date(this.prePostLeaveForm.value.endDate).getTime() + 24 * 60 * 60 * 1000);
            this.noOfDays();
            this.prePostLeaveForm.controls['sessionType'].clearValidators();
            this.prePostLeaveForm.controls['sessionType'].updateValueAndValidity();
        }
    }

    rejectModal(): void {
        this.rejectDialog = this.dialog.open(this.rejectPopup, {
            width: '700px', disableClose: true, panelClass: 'rejectPopup'
        });
    }

    updateValidation(form): void {
        const errorArray = [];
        const controls = form.controls;
        for (const value in controls) {
            if (controls[value].invalid) {
                errorArray.push(value);
            }
        }
        let validationArray = this.commonValidation.getValidation(errorArray);
        let toastvalue = '<h4>Please Check the Followings </h4> <ul>';
        validationArray.forEach(element => {
            toastvalue += '<li>' + element + ' </li>';
        });
        toastvalue += '</ul>';
        this.toastr.warning(toastvalue);
    }

    async confirmationPopUp(form,type): Promise<void> {
        let formValue = form.value;
        console.log('form',form)
        let time = formValue.startTime? formValue.startTime.split(":"): '';
        let sessionTime = time? time[1].includes('am'):'';
        let startDate = new Date(formValue.startDate._d);
        let lastDate = new Date(formValue.endDate._d);
        let result = await this.leaveExistCheck(startDate, lastDate);
        if (result.length == 0) {
            const errorArray = [];
            const controls = form.controls;
            for (const value in controls) {
                if (controls[value].invalid) {
                    errorArray.push(value);
                }
            }
            if(type == 'permissionForm')
            if((formValue.sessionType === 'FN' && !sessionTime )||(formValue.sessionType === 'AN' && sessionTime )){
                errorArray.push('incorrectSessionType')
            }
            if (errorArray.length == 0) {
                this.confirmDialRef = this.dialog.open(this.confirmPopup, {
                    width: '300px',
                    disableClose:true
                });
            }
            else {
                let validationArray = this.commonValidation.getValidation(errorArray);
                let toastvalue = '<h4>Please Check the Followings </h4> <ul>';
                validationArray.forEach(element => {
                    toastvalue += '<li>' + element + ' </li>';
                });
                toastvalue += '</ul>';
                this.toastr.warning(toastvalue);
            }
        }
        if (result.length > 0) {
            let type = result[0].get('leaveType');
            this.toastr.warning('Already ' + type + ' applied for this day');
        }
    }

    close(): void {
        this.dialogRef.close();
    }

    approvePopUp(): void {
       this.approveDialog = this.dialog.open(this.approvePopup, {
            width: '300px',
            disableClose:true
        });
    }

    cancel(): void {
        this.cancelDialog = this.dialog.open(this.cancelPopup, {
            width: '300px',
            disableClose:true
        });
    }

    cancelLeave(): void {
        this.cancelLeaveDialog = this.dialog.open(this.leaveCancelPopup, {
            width: '300px',
            disableClose:true
        });
    }

    enddateUpdater(formType, event): void {
        switch (formType) {
            case 'Permission':
                this.permissionForm.patchValue({
                    endDate: new Date(event.value)
                });
                break;
            default:
                this.permissionForm.patchValue({
                    endDate: new Date(event.value)
                });
        }
    }

    async leaveExistCheck(sDate, lDate): Promise<any> {
        let result = [];
        if (sDate != 'Invalid Date') {
            let startDate = this.dateServiceService.startEndDateByDate(new Date(sDate));
            let leaveQueryInstance = this.parseService.instance.Object.extend('Leaves');
            let leaveQuery = new this.parseService.instance.Query(leaveQueryInstance);
            leaveQuery.equalTo('requesterId', { __type: 'Pointer', className: 'Profile', objectId: this.profileId });
            leaveQuery.greaterThan('startDate', startDate[0]);
            leaveQuery.lessThan('startDate', startDate[1]);
            result = await leaveQuery.find();
        }
        return result;
    }

    startTimeDropdown(val): void {
        this.hoursDropdown = val;
        this.newhours = (this.permissionForm.value.startTime).toUpperCase();
        if (this.newhours != '') {
            let hoursDropdown = this.permissionForm.value.selectHour;
            let time = this.convertTime12to24(this.newhours);
            let hours = Number(hoursDropdown);
            let endTime = this.addMinutes(time, hours == 1 ? '60' : '120');
            this.permissionForm.patchValue({
                endTime: this.tConv24(endTime),
            });
        }
    }

    startTimeChange() {
        this.newhours = (this.permissionForm.value.startTime).toUpperCase();
        if (this.hoursDropdown != undefined) {
            let selectedDrop = this.hoursDropdown;
            let splitValue = this.newhours.split(":");
            let endField = Number(splitValue[0]) + Number(selectedDrop);

            let formattedNumber = ("0" + endField).slice(-2).toString();
            let endTime = formattedNumber + ":" + splitValue[1];

            this.permissionForm.patchValue({
                endTime: endTime,
            });
        }
    }

    dateEstimate(event) {
        this.newhours = (event).toUpperCase();
        this.hoursDropdown = this.permissionForm.value.selectHour;
        if (this.hoursDropdown != undefined && this.hoursDropdown != '') {
            let time = this.convertTime12to24(this.newhours);
            let hours = Number(this.hoursDropdown);
            let endTime = this.addMinutes(time, hours == 1 ? '60' : '120');
            this.permissionForm.patchValue({
                endTime: this.tConv24(endTime),
            });
        }
    }

    tConv24(time24) {
        var ts = time24;
        var H = +ts.substr(0, 2);
        var h = (H % 12) || 12;
        let hours = (h < 10) ? ("0" + h) : h;
        var ampm = H < 12 ? " AM" : " PM";
        ts = hours + ts.substr(2, 3) + ampm;
        return ts;
    };

    addMinutes(time, minsToAdd) {
        function D(J) { return (J < 10 ? '0' : '') + J; };
        var piece = time.split(':');
        var mins = piece[0] * 60 + +piece[1] + +minsToAdd;
        return D(mins % (24 * 60) / 60 | 0) + ':' + D(mins % 60);
    }

    viewDetails() {
        this.showDetails = !this.showDetails;
    }

    async getLeaveDetails() {
        this.leaveResults = [];
        let leaveClass = this.parseService.instance.Object.extend('Leaves');
        let query = new this.parseService.instance.Query(leaveClass);
        query.equalTo('requesterId', { __type: 'Pointer', className: 'Profile', objectId: this.event.requesterId });
        let date = new Date();
        let startend = this.startenddates(date);
        let firstDay = startend[0];
        let lastDay = startend[1];
        query.greaterThan('startDate', firstDay);
        query.lessThan('startDate', lastDay);
        let results = await query.find();
        for (const res of results) {
            let totalHours = 0;
            if (res.get('requestType') == 'Permission') {
                let splitStartTime = (this.convertTime12to24(res.get('startTime'))).split(':');
                let splitEndTime = (this.convertTime12to24(res.get('endTime'))).split(':');
                let startTime = splitStartTime[0] + '.' + splitStartTime[1];
                let endTime = splitEndTime[0] + '.' + splitEndTime[1];
                totalHours = Number(endTime) - Number(startTime);
            }
            this.leaveResults.push({
                requestType: res.get('requestType'),
                status: res.get('status'),
                leaveType: res.get('leaveType'),
                startDate: res.get('startDate'),
                endDate: res.get('endDate'),
                totalDays: res.get('totalDays'),
                startDateValue: this.datePipe.transform(new Date(res.get('startDate')), 'dd-MMM-yyyy'),
                endDateValue: this.datePipe.transform(new Date(res.get('endDate')), 'dd-MMM-yyyy'),
                startTime: res.get('startTime'),
                endTime: res.get('endTime'),
                totalHours: totalHours
            });
        }
    }

    convertTime12to24(time12h) {
        const [time, modifier] = time12h.split(' ');

        let [hours, minutes] = time.split(':');

        if (hours === '12') {
            hours = '12';
        }

        if (modifier === 'PM') {
            hours = parseInt(hours, 10) + 12;
        }

        return `${hours}:${minutes}`;
    }

    startenddates(day) {
        let getTot = this.daysInMonth(day.getMonth(), day.getFullYear(), day.getDate());
        let as = Math.round(getTot / 2);
        day.setDate(as);
        let startdate = this.daybefore(new Date(day));

        let enddate = this.dayafter(day);
        return [startdate, enddate];
    }

    dayafter(d) {
        let day = new Date(d);
        return new Date(day.getFullYear(), day.getMonth() + 1, 0);
    }

    daybefore(d) {
        let day = new Date(d);
        return new Date(day.getFullYear(), day.getMonth(), 1);
    }

    daysInMonth(month, year, date) {
        return new Date(year, month, date).getDate();
    }

}

export interface User {
    name: string;
}

export interface Hour {
    value: string;
    viewValue: string;
}
